import { UntypedFormControl, Validators } from '@angular/forms';
import { FormControlDef } from '@nano/common/form';
import { PaymentConfig, PaymentParam, PaymentType } from '@nano/payment/payment';

export const CurrencyExchangeControls = (config: PaymentConfig): Array<FormControlDef> => [
  {
    name: PaymentParam.operationType,
    control: new UntypedFormControl(PaymentType.CURRENCY_EXCHANGE, [Validators.required])
  },
  {
    name: PaymentParam.beneficiaryAccountNumber,
    control: new UntypedFormControl(null, [
      Validators.required,
      Validators.minLength(config.beneficiaryAccountNumberMinLength),
      Validators.maxLength(config.beneficiaryAccountNumberMaxLength)
    ])
  },
  {
    name: PaymentParam.payerAccount,
    control: new UntypedFormControl(null, [Validators.required])
  },
  {
    name: PaymentParam.payerAccountNumber,
    control: new UntypedFormControl(null, [Validators.required])
  },
  {
    name: PaymentParam.initialAmount,
    control: new UntypedFormControl(undefined, [Validators.required, Validators.min(config.amountMin), Validators.max(config.amountMax)])
  },
  {
    name: PaymentParam.amount,
    control: new UntypedFormControl(undefined, [Validators.required, Validators.min(config.amountMin), Validators.max(config.amountMax)])
  },
  {
    name: PaymentParam.initialCurrency,
    control: new UntypedFormControl(null, [Validators.required])
  },
  {
    name: PaymentParam.currency,
    control: new UntypedFormControl(null, [Validators.required])
  }
];
